import styled from 'styled-components'
import { TAG_COLOR_PALETTE } from '../../../ui/colors/groupColorMap'

export interface ClientCellProps {
  name: string
  sub?: string
}

const hash = (input: string): number => {
  let h = 0
  for (let i = 0; i < input.length; i++) h += input.charCodeAt(i)
  return h
}

const colorFor = (name: string): string =>
  TAG_COLOR_PALETTE[hash(name) % TAG_COLOR_PALETTE.length]

const initials = (name: string): string => {
  const clean = name.replace(/["«»]/g, '').trim()
  const parts = clean.split(/\s+/).filter(Boolean)
  return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? parts[0]?.[1] ?? '')).toUpperCase()
}

/** Avatar (square, hashed color) + primary name and optional secondary line. */
export const ClientCell = ({ name, sub }: ClientCellProps) => (
  <Root>
    <Avatar $bg={colorFor(name)}>{initials(name)}</Avatar>
    <Col>
      <Name>{name}</Name>
      {sub && <Sub>{sub}</Sub>}
    </Col>
  </Root>
)

export default ClientCell

const Root = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
`

const Avatar = styled.span<{ $bg: string }>`
  width: 30px;
  height: 30px;
  border-radius: ${({ theme }) => theme.radii.sm};
  flex-shrink: 0;
  display: grid;
  place-items: center;
  background: ${({ $bg }) => $bg};
  color: #fff;
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: ${({ theme }) => theme.text.xs};
  font-weight: 600;
`

const Col = styled.span`
  display: flex;
  flex-direction: column;
  line-height: 1.25;
  min-width: 0;
`

const Name = styled.span`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.ink};
`

const Sub = styled.span`
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: 10px;
  color: ${({ theme }) => theme.colors.ink4};
`
